import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styles from './table-link.module.css';

export interface TableLinkProps {
  to: string;
  title?: string;
  /** Single-line ellipsis truncation (for wide cells like service names). */
  truncate?: boolean;
  children: ReactNode;
}

/**
 * The one in-table hyperlink style, used by every list column that links out
 * (customer / contract / invoice ids, service names, …). Guarantees uniform
 * colour, weight, size and hover across all tables — do NOT inline per-cell link
 * styles. `stopPropagation` lets a row's `onRowClick` fire without double-nav.
 */
export function TableLink({ to, title, truncate, children }: TableLinkProps) {
  return (
    <Link
      to={to}
      title={title}
      onClick={(e) => e.stopPropagation()}
      className={truncate ? `${styles.link} ${styles.truncate}` : styles.link}
    >
      {children}
    </Link>
  );
}
